import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import ApprovePRAProcessController from './approve-process.controller';
import processDirective from './approve-process.directive';


export default angular.module('app.components.advisory.pra.approveProcess', [
  ssDialogService,
  loaderService,
  alerts,
  actionIcon,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
  confirmDialog,
])
  .directive('approvePraProcess', processDirective)
  .controller('ApprovePRAProcessController', ApprovePRAProcessController)
  .name;

console.log('app.components.advisory.pra.approveProcess created');
